<template>
  <div
    v-if="loadedPage"
    class="entity-progress"
    :class="{
      'progress--done': isDone,
      'progress--flagged': isFlagged,
      'progress--issue': hasIssue,
    }">
    <div
      v-for="(check, index) in receiptProgress"
      :key="index"
      class="progress-check"
      :class="{
        'progress--with-titles': titles,
      }"
      @click="$emit('clicked', check)">
      <span v-if="titles" class="check-label">{{ check.label }}</span>
      <iconComponent
        :symbol="check.symbol"
        :stroke="getIconColor(check)"
        :fill="getIconColor(check)"/>
      <span class="tooltip">{{ getTooltip(check) }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "ReceiptProgress",
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    titles: {
      type: Boolean,
      default: false,
    },
    receipt: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    userType() {
      return this.admin ? 'Admin' : 'Company';
    },
    routesName() {
      return this.admin ? 'Admin' : 'Partner';
    },
    hasIssue() {
      return (!!this.receipt.receipt_issue && this.receipt.receipt_issue !== 'none')
        || !!this.receipt.cta_issue;
    },
    isFlagged() {
      return this.receipt.flagged;
    },
    isDone() {
      return this.receipt.cta_done;
    },
    receiptProgress() {
      const steps = [];
      try {
        const activation = this.receipt.activation;
        let status = null;

        if (activation.receipt_step) {
          status = this.receipt.confirmed_receipt;
          steps.push({ label: 'PV', tooltip: 'Receipt step', status, symbol: 'receipt', n: 0 });
        }
        if (activation.registration_step) {
          status = this.receipt.confirmed_registration;
          steps.push({ label: 'PR', tooltip: 'Product registration step', status, symbol: 'medal', n: 1 });
        }
        if (activation.survey_step) {
          status = this.receipt.confirmed_survey;
          steps.push({ label: 'Survey', tooltip: 'Survey step', status, symbol: 'survey', n: 2 });
        }
        if (activation.address_step) {
          status = this.receipt.confirmed_address;
          steps.push({ label: 'Address', tooltip: 'Address step', status, symbol: 'mapPin', n: 3 });
        }
        if (activation.payment_step) {
          status = this.receipt.confirmed_payment;
          steps.push({ label: 'Payment', tooltip: 'Payment step', status, symbol: 'wallet', n: 4 });
        }
        if (activation.review_step) {
          status = this.receipt.confirmed_review;
          steps.push({ label: 'Review', tooltip: 'Review step', status, symbol: 'review', n: 5 });
        }
        if (activation.cashback_step) {
          status = this.receipt.confirmed_cashback;
          steps.push({ label: 'Cashback', tooltip: 'Cashback step', status, symbol: 'cashback', n: 6 });
        }
        status = !this.receipt.cta_issue && this.receipt.cta_done;
        steps.push({ label: 'Done', tooltip: 'Completed', status, symbol: 'done', n: 7 });
      } catch (e) {
        console.error('Error in receiptProgress:', e);
      }

      return steps;
    },
    stepNumber() {
      let stepNumber = 0;
      const activation = this.receipt.activation;
      let theReceipt = this.receipt;
      if (theReceipt.cta_issue) {
        stepNumber = 7;
      } else if (activation.receipt_step && !theReceipt.confirmed_receipt) {
        stepNumber = 0;
      } else if (activation.registration_step && !theReceipt.confirmed_registration) {
        stepNumber = 1;
      } else if (activation.survey_step && !theReceipt.confirmed_survey) {
        stepNumber = 2;
      } else if (activation.address_step && !theReceipt.confirmed_address) {
        stepNumber = 3;
      } else if (activation.payment_step && !theReceipt.confirmed_payment) {
        stepNumber = 4;
      } else if (activation.review_step && !theReceipt.confirmed_review) {
        stepNumber = 5;
      } else if (activation.cashback_step && !theReceipt.confirmed_cashback) {
        stepNumber = 6;
      } else {
        stepNumber = 7;
      }

      return stepNumber;
    },
  },
  data() {
    return {
      loadedPage: true,
      detailedInfoModal: false,
    };
  },
  watch: {
  },
  methods: {
    getIconColor({ status, n }) {
      const current = this.stepNumber === n;

      if (status && current) {
        return this.isFlagged ? 'orange' : 'green';
      } else if (current) {
        return this.isFlagged ? 'orange' : (this.hasIssue ? 'red' : 'blue');
      } else if (status && !current) {
        return 'green';
      } else {
        return 'grey';
      }
    },
    getTooltip({ tooltip, status, n }) {
      let message = '';
      const current = this.stepNumber === n;

      if (this.isFlagged && current) {
        message = 'Flagged';
      } else if (this.hasIssue && current) {
        message = 'Issue';
      } else if (current) {
        message = 'Current';
      } else if (status) {
        message = 'Completed';
      }

      message += `${message ? ': ': ''}${tooltip}`;
      return message;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./ReceiptProgress.scss";
</style>
